import ReactDOM from "react-dom";
import React from "react";
import FundMedicationListing from "../components/fund-medication-listing/FundMedicationListing";

// decode HTML entities from attribute -> plain JSON string
function decodeHtmlEntities(s) {
  const el = document.createElement("textarea");
  el.innerHTML = s;
  return el.value;
}

const init = () => {
  let mountPoint = document.querySelector("#FundMedicationListing");

  if (mountPoint) {
    /* parse optional data attributes for potential maintenance message*/
    const maintenance = mountPoint.getAttribute("data-maintenance");
    const maintenanceMessageLine1 = mountPoint.getAttribute(
      "data-maintenance-message-line-1"
    );
    const maintenanceMessageLine2 = mountPoint.getAttribute(
      "data-maintenance-message-line-2"
    );

    const titlesMapAttr = mountPoint.getAttribute("data-titles-map") || "{}";

    let titlesMap = {};
    try {
      const decoded = decodeHtmlEntities(titlesMapAttr);
      titlesMap = JSON.parse(decoded);
    } catch (e) {
      console.log("Failed to parse data-titles-map:", e, { titlesMapAttr });
      titlesMap = {};
    }

    ReactDOM.render(
      <FundMedicationListing
        maintenance={maintenance}
        maintenanceMessageLine1={maintenanceMessageLine1}
        maintenanceMessageLine2={maintenanceMessageLine2}
        titlesMap={titlesMap}
      />,
      mountPoint
    );
  }
};

// Init on initial page load
init();
